import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Notification = ({ message }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false); // Auto-hide after 20 seconds
    }, 20000);

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ type: 'spring', stiffness: 100, damping: 15, duration: 0.8 }}
      className="fixed top-5 right-5 w-96 p-6 rounded-3xl shadow-lg flex items-center justify-between backdrop-blur-lg border border-gray-200 dark:border-gray-700 z-50"
    >
      <div className="flex items-center space-x-4">
        {/* Icon for visual style */}
        <div className="w-12 h-12 bg-opacity-30 backdrop-blur-md rounded-full flex items-center justify-center border border-gray-200 dark:border-gray-700">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-800 dark:text-white transition-transform duration-300 transform hover:rotate-12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <span className="font-semibold text-lg text-gray-800 dark:text-white drop-shadow-lg">
          {message}
        </span>
      </div>
      <button
        onClick={() => setVisible(false)}
        className="ml-4 text-2xl text-gray-800 dark:text-white transition-transform duration-300 
                   transform hover:scale-125 hover:shadow-lg hover:shadow-pink-500/50 hover:rounded-full"
      >
        &times;
      </button>
    </motion.div>
  );
};

export default Notification;
